var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ez-button',{staticClass:"dropdown-actions__btn dropdown-actions__btn--complete",attrs:{"disabled":_vm.disabled,"type":_vm.type},on:{"click":function($event){return _vm.$emit('actionClicked')}}},[_vm._v(" Receive ")])
}
var staticRenderFns = []

export { render, staticRenderFns }